export default __webpack_public_path__ + "assets/e2d60bc49517598c0ce8b98f8d4e579f.ttf";